export function searchHighlight(cSearchText, cTextElementClass) {
    const textList = document.querySelectorAll(cTextElementClass || ".highlightFilterText")

    if (!textList?.length) return

    textList?.forEach((x) => {
        const re = new RegExp(cSearchText, "i")
        if (re.test(x.textContent))
            x.innerHTML = x.textContent.replace(re, "<mark>$&</mark>")
    })
}